module.exports = __webpack_public_path__ + "static/media/me_wedding_compressed_cropped_4.801d234e.jpg";